export function formatNumberToPtBr(valor: number): string {
    return valor.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export function apenasNumero(texto: string) {
    // O método replace com a regex /\D/g remove tudo o que NÃO for número
    return texto.replace(/\D/g, '');
}